import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@ui-kit/buttons';

@Component({
    selector: 'app-unauthorized-page',
    standalone: true,
    templateUrl: './unauthorized-page.component.html',
    styleUrls: ['./unauthorized-page.component.scss'],
    imports: [ButtonComponent, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnauthorizedPageComponent {
    private auth0 = inject(AuthService);

    async logout(): Promise<void> {
        const url = `${environment.auth0.logoutUrl}?client_id=${environment.auth0.clientId}&returnTo=${encodeURI(
            environment.auth0.logoutReturnUrl
        )}`;

        await this.auth0.logout({
            openUrl(_url: string) {
                window.location.replace(url);
            },
        });
    }
}
